import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class HttpService {

  private readonly http = inject(HttpClient);
  constructor() { }

/**
 * Makes an HTTP request using the specified method, environment, and route.
 *
 * @template T - The expected response type.
 * @param { 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE' } method - The HTTP method for the request.
 * @param { string } env - The base URL of the environment (e.g., development, staging, production).
 * @param { string } route - The API endpoint route (should start with `/`).
 * @param { object } [data] - Optional payload for POST and PUT requests, or query params for GET.
 * @returns { Observable<T> } - An observable that emits the response data of type `T`.
 * @throws { Error } - Throws an error if an unsupported HTTP method is used.
 */
sendApiRequest<T>(method: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE', env: string, route: string, data?: object): Observable<T> {
  // Construct the full URL using the provided environment and route
  let url = `${env}${route}`;

  // Perform the API request based on the provided HTTP method
  switch (method) {
    case 'GET':
      // For GET requests, convert data object to query parameters
      if (data) {
        const params = new URLSearchParams();
        Object.entries(data).forEach(([key, value]) => {
          if (value !== null && value !== undefined) {
            params.append(key, String(value));
          }
        });
        url += `?${params.toString()}`;
      }
      return this.http.get<T>(url);

    case 'POST':
      return this.http.post<T>(url, data);

    case 'PUT':
      return this.http.put<T>(url, data);

    case 'PATCH':
      return this.http.patch<T>(url, data);

    case 'DELETE':
      return this.http.delete<T>(url, {body: data});

    default:
      throw new Error(`Unsupported HTTP method: ${method}`);
    }
  }
}

